import { frontendURL } from '../../../helper/URLHelper';

const DashboardAppView = () => import('./DashboardAppView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/apps/:appId'),
    name: 'dashboard_app_view',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: DashboardAppView,
  },
];
